import { createListenerMiddleware, Dispatch, ListenerEffectAPI, UnknownAction } from '@reduxjs/toolkit'
import { appActions } from '../slices/appSlice'
import { RootState } from '../store'

const appMiddleware = createListenerMiddleware()

const effect = (_: UnknownAction, listenerApi: ListenerEffectAPI<unknown, Dispatch>) => {
  const state = listenerApi.getState() as RootState
  const userId = state.user.userId
  if (userId) {
    const appState = state.app
    const settings = {
      isUtc: appState.isUtc,
      isDarkMode: appState.isDarkMode,
      isChartOpen: appState.isChartOpen,
    }
    localStorage.setItem(`user-${userId}`, JSON.stringify({ ...settings }))
  }
}

appMiddleware.startListening({ actionCreator: appActions.setUtc, effect })
appMiddleware.startListening({ actionCreator: appActions.setDarkMode, effect })
appMiddleware.startListening({ actionCreator: appActions.setChartClosed, effect })

export default appMiddleware
